import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overview = _resolveComponent("Overview")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Popup, { onShowOverview: _ctx.showOverview }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createBlock(_component_Overview, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onShowOverview"])
  ]))
}